import { AloftPrice, ManualAdjustments, manualAdjustmentKeys } from '@aloft/toolkit-shared';
import { Button, Modal } from '@aloft/toolkit-sui';

import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { setManualAdjustments } from '../../redux/features/propertyDataSlice.ts';
import { useAppDispatch } from '../../redux/hooks.ts';
import { PropertyGridForm } from './types.ts';
import { handleUpdatePropertyData } from './utils.ts';

type ResetAdjustmentsButtonProps = {
  columnIndex: number;
};

export const ResetAdjustmentsButton = ({ columnIndex }: ResetAdjustmentsButtonProps) => {
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const { setValue, watch } = useFormContext<PropertyGridForm>();

  const onClose = () => setIsOpen(false);

  const { propertyId, propertyData } = watch(`columns.${columnIndex}`);

  const resetManualAdjustments = () => {
    const newManualAdjustments = manualAdjustmentKeys.reduce((acc, key) => {
      if (['concessions', 'termsOfSale'].includes(key)) {
        acc[key] = AloftPrice.zero.toJSON();
      } else {
        acc[key] = undefined;
      }

      return acc;
    }, {} as ManualAdjustments);

    setValue(
      `columns.${columnIndex}.propertyData.editableData.manualAdjustments`,
      newManualAdjustments,
    );

    dispatch(setManualAdjustments([{ id: propertyId, changes: newManualAdjustments }]));
    if (propertyData) handleUpdatePropertyData(propertyData, propertyId, watch(), dispatch);
  };

  return (
    <>
      <Button variant="secondary" size="sm" text="Reset" onClick={() => setIsOpen(true)} />
      <Modal
        size="lg"
        isOpen={isOpen}
        onClose={onClose}
        closeOnEsc
        title="Reset Adjustments"
        primaryAction={{
          text: 'Reset',
          onClick: () => {
            resetManualAdjustments();
            onClose();
          },
        }}
        secondaryAction={{
          text: 'Cancel',
          onClick: onClose,
        }}
      >
        Do you want to reapply the adjustment values calculated with Depreciated Cost? Please note
        that all manual adjustments made on this Comp will be lost.
      </Modal>
    </>
  );
};
